import React from "react";
import { T } from "../../../traks";
import { Col } from "reactstrap";
import { formatPrice } from "./GlobalUtils";

const OrderTotal = ({ idx, total, totalNoVat, currency, colSize=12}) => {
  return (
    <Col sm={colSize}>
        <span>
            <T>Order total: </T> {formatPrice(total)} {currency}
        </span>
        <span className='checkout-price-no-vat'>
         &nbsp; ({formatPrice(totalNoVat)} {currency}<T>&nbsp;excl. VAT)</T>
        </span>
    </Col>
  );
};

export default OrderTotal;


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Globals/OrderTotal.js